import { API_AUTH, API_AUTH_FILE } from "../common";

const LoiNhuanApi = {
  getSummary: (dateFrom, dateTo) => 
    API_AUTH.get(`api/baocao/SummaryLoiNhuan?dtFrom=${dateFrom}&dtTo=${dateTo}`),

  getChart: (dateFrom, dateTo) => 
    API_AUTH.get(`api/baocao/ChartLoiNhuan?dtFrom=${dateFrom}&dtTo=${dateTo}`),

  getChiTiet: (dateFrom, dateTo, loaiBaoCao, pageIndex, pageSize) => 
    API_AUTH.get(`api/baocao/ChiTietLoiNhuan?dtFrom=${dateFrom}&dtTo=${dateTo}&loaiBaoCao=${loaiBaoCao}&pageIndex=${pageIndex}&pageSize=${pageSize}`),

  exportExcel: (dateFrom, dateTo, loaiBaoCao) => 
    API_AUTH_FILE.get(`api/baocao/xuat-bao-cao-loi-nhuan?dtFrom=${dateFrom}&dtTo=${dateTo}&loaiBaoCao=${loaiBaoCao}`, {},{ responseType: 'blob' }),
}

export default LoiNhuanApi;